<template>
  <on-click-outside :do="close">
    <div ref="selector" class="flex flex-col md:w-full relative bg-white "
         :class="[withTeamCreate ? '' : 'rounded-sm border-additional-text']">
      <div class="font-bold flex flex-row justify-between text-menuOrder-dark-blue relative ref  "
           :class="{'border border-additional-text rounded': isReason, 'justify-between'
      : arrowOnTheRight, 'py-2' : !no_padding, 'cursor-default'
      : disabled,'cursor-pointer' : !disabled, 'justify-between'
      : between, 'pr-3' : needsInnerPadding }"
           @click="onClick">
        <div class="text-main-text whitespace-no-wrap" :class="[{'text-additional-text': popIsGrey,
       'font-normal': fontIsNormal, 'text-grey': disabled, 'hidden md:block': hideHeading,
       'pl-4 py-1' : needsInnerPadding, 'text-additional-text' : displayValue == this.placeholder
       && needsInnerPadding}]" v-html="displayValue"></div>
        <img v-if="!disabled && !hideArrow" :class="arrowDownClasses"
             class="md:mr-1 md:ml-4 md:w-3 ml-3 mr-05"
             src="@/assets/SVG/arrow_down.svg"
             alt="arrow_down"/>
      </div>
      <div v-if="disabled&&showDisabledMessage"
           v-text="disabledErrorText"
           class="p-4 font-normal text-sm text-main-text bg-white md:max-w-50 border
          border-main-text absolute pin-t pin-l mt-8 mr-6 z-20">
        будет комментарий, который указан в модалке во время регистрации
      </div>

      <div ref="showBox"
           id="showBox"
           class="mb-5 bg-white items-center w-full absolute z-20  rounded md:py-1 max-h-third-screen overflow-y-auto back-shadow"
           v-show="showBox" :class="[is_place? 'place-width' : '',
          positionLeft ? 'adjusting-popper' : '', positionBottom ? 'position-bottom' : '',
          positionBottomInfo ? 'position-bottom-info' : '' ]">
        <div v-if="returnAll && !listItem.hidden"
             class="w-full flex py-2 flex-row justify-between px-4 cursor-pointer select-none font-medium z-50 selectedLabel"
             :class="[listItem.disabled ? 'cursor-auto text-additional-text bg-transparent' : '', value == key ? 'mobile-brand-light' : '',]"
             v-for="(listItem, key) in sortedOptions"
             @click.stop="selectListItemClick(key , listItem)" :key="key">
          <p>{{ listItem.name }}
            <!--<span v-if="listItem.disabled">(отправьте статистику предыдущей игры)</span>-->
          </p>
          <img v-if="!listItem.disabled" src="@/assets/SVG/tick.svg" alt="">
        </div>
        <div v-if="!returnAll && !listItem.hidden"
             class="w-full py-2 px-4 cursor-pointer select-none font-medium z-50 selectedLabel"
             :class="[listItem.disabled ? 'cursor-auto text-additional-text bg-transparent' : '', value === key ? 'mobile-brand-light' : '',]"
             v-for="(listItem, key) in sortedOptions" @click.stop="selectListItemClick(key)" :key="key">
          <div class="flex flex-row justify-between"><p>{{ listItem.name }}
            <!--<span v-if="listItem.disabled">(отправьте статистику предыдущей игры)</span>-->
          </p>
            <img v-if="!listItem.disabled" src="@/assets/SVG/tick.svg" alt=""></div>

          <div class="flex items-center mt-1" v-if="listItem.review_count">
            <img src="@/assets/SVG/rating-star.svg" alt="" class="mr-1">
            <p class="mr-1 text-xs">{{ listItem.rating }}</p>
            <p class="text-additional-text text-10px">({{ listItem.review_count }} {{ getGrades(listItem) }})</p>
          </div>

        </div>
        <div v-if="withTeamCreate" @click.prevent="newTeamCreate"
             class="flex flex-row  items-center cursor-pointer p-4"
        >
          <button class="hover-up rounded-full flex flex-row justify-center items-center w-8 h-8
                outline-none "
                  :class="teamCreatingIsDisabled? 'bg-additional-text':'bg-brand-light'">
            <font-awesome-icon class="text-white text-xl" :icon="['fal', 'plus']"></font-awesome-icon>
          </button>
          <div class="text-xs font-medium ml-4"
               :class="teamCreatingIsDisabled? 'text-additional-text':'text-brand-light'">Создать команду
          </div>
        </div>
      </div>
    </div>
  </on-click-outside>
</template>
<script>
import Popper from 'popper.js';
import OnClickOutside from '../../views/OnClickOutside.vue';

export default {
  name: 'selectbox',
  components: { OnClickOutside },
  props: {
    isReason: {
      type: Boolean,
      default: false,
    },
    listItems: {},
    value: [Number, String],
    placeholder: String,
    popIsGrey: {
      type: Boolean,
      default: false,
    },
    arrowOnTheRight: {
      type: Boolean,
      default: false,
    },
    withTeamCreate: {
      type: Boolean,
      default: false,
    },
    teamCreatingIsDisabled: {
      type: Boolean,
      default: false,
    },
    selected_team: {
      type: Boolean,
    },
    is_place: {
      type: Boolean,
      default: false,
    },
    no_padding: {
      type: Boolean,
      default: false,
    },
    fontIsNormal: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledErrorText: {
      type: String,
      default: 'Нельзя изменить этот параметр',
    },
    sortType: {
      type: String,
    },
    positionLeft: {
      type: Boolean,
      default: false,
    },
    hideHeading: {
      type: Boolean,
      default: false,
    },
    between: {
      type: Boolean,
      default: false,
    },
    hideArrow: {
      type: Boolean,
      default: false,
    },
    needsInnerPadding: {
      type: Boolean,
      default: false,
    },
    positionBottom: {
      type: Boolean,
      default: false,
    },
    positionBottomInfo: {
      type: Boolean,
      default: false,
    },
    onRegistrationModal: {
      type: Boolean,
      default: false,
    },
    returnAll: {
      type: Boolean,
      default: false,
    },
    arrowDownClasses: {
      type: String,
      default: 'ml-3 md:ml-4',
    },
  },

  data() {
    return {
      showBox: false,
      showDisabledMessage: false,
    };
  },
  watch: {
    showBox() {
      if (this.showBox) {
        this.setupPopper();
        this.$emit('hideTeamCreate');
      }
    },
    showDisabledMessage() {
      if (this.showDisabledMessage) {
        document.addEventListener('click', this.onClick);
        // this.$emit('hideTeamCreate')
      } else {
        document.removeEventListener('click', this.onClick);
      }
    },
    selected_team() {
      if (this.selected_team) {
        this.selectListItemClick(0);
      }
    },
  },
  created() {
    this.hideSelectboxHandler = () => {
      this.hideBox();
    };
  },

  beforeDestroy() {
    if (this.popper) {
      this.popper.destroy();
    }
  },
  methods: {
    close() {
      if (!this.showBox) {
        return;
      }
      this.showBox = false;
    },
    newTeamCreate() {
      if (!this.teamCreatingIsDisabled) {
        this.$emit('newTeamCreate');
        this.showBox = false;
      }
    },
    openBox() {
      this.showBox = true;
    },
    setupPopper() {
      if (this.popper === undefined) {
        this.popper = new Popper(this.$refs.selector, this.$refs.showBox, {
          placement: this.is_place ? 'bottom-start' : 'bottom',
        });
      } else {
        this.popper.scheduleUpdate();
      }
    },
    selectListItemClick(key, listItem) {
      let tempKey = key;
      if (this.sortType) {
        Object.keys(this.listItems)
          .forEach((item) => {
            if (this.listItems[item].id === this.sortedOptions[key].id) {
              tempKey = item;
            }
          });
      }
      if (this.listItems[tempKey].disabled) return;
      this.showBox = false;
      this.$emit('hideTeamCreate');
      if (this.returnAll) {
        this.$emit('input', {
          key,
          selectedOption: listItem.subType.data,
        });
      } else {
        this.$emit('input', key);
      }
    },
    hideBox() {
      this.showBox = false;
    },

    onClick() {
      if (this.disabled) {
        this.showDisabledMessage = !this.showDisabledMessage;
        return;
      }
      if (this.selected_team) return;

      this.showBox = !this.showBox;
    },
    getGrades(listItem) {
      let reviewCount = listItem.review_count;
      reviewCount = Math.abs(reviewCount) % 100;
      const num = reviewCount % 10;
      if (reviewCount > 10 && reviewCount < 20) return 'оценок';
      if (num > 1 && num < 5) return 'оценки';
      if (num === 1) return 'оценка';
      return 'оценок';
    },
  },
  computed: {
    displayValue() {
      return this.listItems[this.value] ? this.listItems[this.value].name : this.placeholder;
    },
    sortedOptions() {
      if (this.sortType) {
        if (this.sortType === 'natural') {
          // convert object to array to make sort and add key to the array
          const myArray = Object.keys(this.listItems)
            .map(key => ({
              value: this.listItems[key],
              key,
            }));

          const collator = new Intl.Collator(undefined, {
            numeric: true,
            sensitivity: 'base',
          });

          // sorting depend on names (note:keys also be sorted!! first time by name then by order)
          myArray.sort((a, b) => collator.compare(a.value.name, b.value.name));
          myArray.sort((a, b) => collator.compare(a.value.order, b.value.order));

          const keys = [];
          myArray.forEach(item => keys.push(item.key));

          // function to convert array to object
          const convertArrayToObject = (array, key) => {
            const initialValue = {};

            return array.reduce((obj, item, index) => ({
              ...obj,
              [key[index]]: item,
            }), initialValue);
          };

          // remove key in sorted array and keep only values
          const newArray = [];
          myArray.forEach(item => newArray.push(item.value));

          return convertArrayToObject(newArray, keys);
        }
        const templateObj = {};

        Object.keys(this.listItems)
          .sort((itemA, itemB) => {
            if (this.sortType === 'id') {
              return this.listItems[itemA].id > this.listItems[itemB].id ? 1 : -1;
            } else if (this.sortType === 'abc') {
              return this.listItems[itemA].name > this.listItems[itemB].name ? 1 : -1;
            }
            return 0;
          })
          .forEach((item, index) => {
            templateObj[index] = this.listItems[item];
          });
        return templateObj;
      }
      return this.listItems;
    },
  },
};
</script>

<style scoped lang="less">
.selectedLabel {
  color: #333333;
  z-index: 60;

  &:hover {
    color: white;
    background-color: #BD006C;
  }
}

.showBox {
  min-width: fit-content !important;
}

.place-width {
  min-width: 300px;
}

.back-shadow {
  background: #FFFFFF;
  border: 0.5px solid #DADADA;
  box-sizing: border-box;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1), 0px 0px 2px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
}

@media (max-width: 840px) {
  .mobile-brand-light {
    background-color: #BD006C;
    color: white;
  }

  .place-width {
    min-width: 295px;
  }

  .adjusting-popper {
    transform: translate(-170px, 20px) !important
  }

  .position-bottom {
    width: 90vw;
    transform: translate(3px, 40px) !important
  }

  .position-bottom-info {
    width: 90vw;
    transform: translate(3px, 20px) !important
  }

  .mr-05 {
    margin-right: 2px;
  }
}
</style>
